import { Modal, Progress, Typography } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { Sheet } from 'react-modal-sheet';
import { AppContext } from '../../../../App';
import LoaderIcon from '../../../../Assets/yesbank/loaderStatic.png';
import { getAltJourney, getIsNewUser } from '../../../../Utils/storageUtils';
import { altJourneyType, LOADERTYPE } from '../../../../Utils/types';
import styles from './index.module.css';

const YesBankLoader = () => {
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(true);
  const [percent, setPercent] = useState(5);

  const { loaderType, isLoading }: any = useContext(AppContext);

  useEffect(() => {
    setInterval(() => {
      setPercent((percent) => (percent < 90 ? percent + 3 : 90));
    }, 500);
  }, []);

  const renderContent = () => {
    return (
      <div className={styles.container}>
        {loaderType === LOADERTYPE.GENERIC ? (
          <>
            <img
              src={LoaderIcon}
              alt='Loader Lottie'
              style={{ width: 56, height: 49 }}
            />
            <Typography.Text className={styles.loaderText}>
              Provide your primary accounts to get more accurate insights!
            </Typography.Text>
            <Progress
              style={{ marginTop: 16 }}
              percent={percent}
              showInfo={false}
            />
          </>
        ) : (
          <>
            <img
              src={LoaderIcon}
              alt='Loader Lottie'
              style={{ width: 56, height: 49 }}
            />
            <Typography.Text className={styles.loaderText}>
              Generating your insights{' '}
            </Typography.Text>
            <Progress
              style={{ marginTop: 16 }}
              percent={percent}
              showInfo={false}
            />
          </>
        )}
      </div>
    );
  };

  return isLoading ? (
    getAltJourney() === altJourneyType.YESONLINE && window.innerWidth > 428 ? (
      <Modal
        rootClassName='modalRoot'
        closeIcon={null}
        className='revokeConsentSheet ybModal'
        footer={null}
        open={true}
      >
        {renderContent()}
      </Modal>
    ) : (
      <Sheet
        style={{ zIndex: 5 }}
        isOpen={isLinkModalOpen}
        onClose={() => {
          setIsLinkModalOpen(false);
        }}
        detent='content-height'
        disableScrollLocking={true}
      >
        <Sheet.Container className={styles.sheet_container_loader}>
          <Sheet.Content>{renderContent()}</Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop
          style={{
            background: getIsNewUser()
              ? 'rgba(0,0,0,0.6)'
              : 'rgba(0, 0, 0, 0.2)',
          }}
        />
      </Sheet>
    )
  ) : (
    <></>
  );
};

export default YesBankLoader;
